import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Barre de confirmation fixe pour les écrans de création.
 */
@Component({
    selector: 'app-creation-confirm-bar',
    templateUrl: './creation-confirm-bar.component.html',
    styles: [`
        :host {
            position: fixed;
            bottom: 50px;
            left: 0;
            right: 0;
            z-index: 1000;
            display: flex;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 1rem;
            padding-bottom: env(safe-area-inset-bottom, 0px);
            pointer-events: none;
        }

        .creation-confirm-bar {
            pointer-events: auto;
            width: max-content;
            max-width: min(calc(100vw - 2rem), var(--creation-confirm-bar-max-width, 48rem));
        }

        .creation-confirm-bar__inner {
            display: grid;
            width: max-content;
            max-width: 100%;
            padding: 0.5rem;
            border: 1px solid var(--surface-border);
            border-radius: var(--border-radius);
            background: var(--surface-overlay);
            box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.12);
        }

        :host ::ng-deep .creation-confirm-bar__inner .p-button,
        :host ::ng-deep .creation-confirm-bar__inner .p-button .p-button {
            width: 100%;
            min-height: 3.25rem;
            font-size: 1.125rem;
            padding: 0.875rem 1.5rem;
        }

        :host ::ng-deep .creation-confirm-bar__inner .p-button .p-button-icon {
            font-size: 1.125rem;
        }

        @media (prefers-reduced-motion: no-preference) {
            .creation-confirm-bar__inner {
                transition: box-shadow 0.2s ease;
            }
        }
    `]
})
export class CreationConfirmBarComponent {
    @Input() label: string = 'Confirmer';
    @Input() loadingLabel: string = 'Création…';
    @Input() icon: string = 'pi pi-check';
    @Input() loading: boolean = false;
    @Input() disabled: boolean = false;
    @Input() maxWidth: string = '48rem';

    @Output() confirm = new EventEmitter<void>();
}
